export default __webpack_public_path__ + "static/media/icon-issues.ba768f7f.svg";